import { SectionField } from "types/Models/Filing";
import { isConditionMet } from "./isConditionMet";
import { isHiddenForRole } from "./isHiddenForRole";

const NO_RADIO_VALUES = {};

// visibility from the form values and viewer role, so validation does not depend on what is rendered
export const isUploadOrLinkRequired = (
  field: Pick<
    SectionField,
    "required" | "radio" | "is_hidden_for_admin" | "is_hidden_for_customer"
  >,
  values: Record<string, unknown>,
  isCustomer: boolean
): boolean =>
  Boolean(field.required) &&
  !isHiddenForRole(field, isCustomer) &&
  isConditionMet(field, NO_RADIO_VALUES, values);
